<div class="page-container">
  <div class="pricing-content scrollable-content">
    <div class="pricing-header">
      <h1>{{ 'pricing.title' | translate }}</h1>
      <p class="tagline">{{ 'pricing.tagline' | translate }}</p>
    </div>

    @if (state() === 'loading') {
      <div class="loading-container flex flex-column flex-align-center p-lg">
        <app-spinner />
      </div>
    }

    @if (state() === 'error') {
      <div class="error-container p-lg" data-testid="pricing-error">
        <p>{{ 'pricing.loadError' | translate }}</p>
      </div>
    }

    @if (state() === 'loaded') {
      <div class="plans-grid">
        @for (plan of plans(); track plan.id) {
          <app-card class="plan-card" [attr.data-testid]="'plan-card-' + plan.id">
            <div class="plan-card-content flex flex-column gap-md p-lg">
              <h2>{{ plan.name }}</h2>

              @if (plan.selfServe) {
                <div class="plan-price">
                  <span class="price-amount">{{ formatPrice(plan.priceMonthlyCents) }}</span>
                  <span class="price-period">{{ 'pricing.perMonth' | translate }}</span>
                </div>
              } @else {
                <div class="plan-price">
                  <span class="price-amount">{{ 'pricing.contactSales' | translate }}</span>
                </div>
              }

              <ul class="plan-limits">
                <li>
                  {{ plan.recordLimit === null ? ('pricing.unlimitedRecords' | translate) : plan.recordLimit + ' ' + ('pricing.records' | translate) }}
                </li>
                <li>
                  {{ plan.seatLimit === null ? ('pricing.unlimitedSeats' | translate) : plan.seatLimit + ' ' + ('pricing.seats' | translate) }}
                </li>
              </ul>

              @if (plan.selfServe) {
                <app-button variant="filled" (click)="selectPlan(plan)" [attr.data-testid]="'plan-select-' + plan.id">
                  {{ 'pricing.getStarted' | translate }}
                </app-button>
              } @else {
                <a [href]="'mailto:' + salesEmail" class="btn-contact-sales" data-testid="plan-contact-sales">
                  {{ 'pricing.contactUs' | translate }}
                </a>
              }
            </div>
          </app-card>
        }
      </div>
    }
  </div>
</div>
